/* 🤖 this file was generated by svg-to-ts */
export const mgcIconWineglass2Regular: {
  name: 'wineglass-2-regular';
  data: string;
} = {
  name: 'wineglass-2-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.78 3.067a1.648 1.648 0 0 0-.791.575c-.207.295-.283.574-.261.96.035.603-.222.313 4.257 4.798L11 13.421V19H9.947c-1.241 0-1.363.022-1.641.3a.96.96 0 0 0 0 1.4c.312.311.174.3 3.694.3 3.525 0 3.382.012 3.697-.303.183-.183.303-.46.303-.697s-.12-.514-.303-.697c-.281-.281-.4-.303-1.644-.303H13v-5.579l4.015-4.02c4.478-4.486 4.222-4.196 4.257-4.799.032-.556-.193-1.027-.635-1.328-.433-.294.206-.274-8.675-.271-7.033.002-8.006.01-8.182.064M15.29 8.29 12 11.58 8.71 8.29 5.42 5h13.16z"/></svg>`
};
